export default [
    // 拦截单
    {
        path: "intercept/list",
        name: "interceptList",
        component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/index"),
    },
    {
        path: "intercept/managelist",
        name: "interceptManegeList",
        component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/manageindex"),
    },
    {
        path: "intercept/update/:type",
        name: "interceptUpdate",
        component: () => import(/* webpackChunkName: "intercept" */ "@/views/intercept/update"),
    }
]